export default function AboutSection() {
  return (
    <section id="about-site" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="font-label text-sm text-primary-600 font-medium">本页说明</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              这是一个入口导航页，<br className="hidden md:block" />
              不是内容页
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            <p>
              你正在浏览的是一个<strong className="font-semibold text-foreground-950">入口导航页</strong>。
              它的作用是帮你找到并记住「桃花视频」的官网入口与最新地址，
              并在站点换域名、调整跳转方式之后，把变化同步到这里，让你不必一次次重新搜索。
            </p>
            <p>
              本页<strong className="font-semibold text-foreground-950">不提供、不存储任何视频内容</strong>，
              也不要求你注册账号、付费或下载软件。它更像一个贴在墙上的「公告板」：
              你只需要记住它，之后无论地址怎么变，都回到这里看最新指引。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <div className="flex items-center gap-2 text-primary-700 font-medium text-sm">
                  <i className="ri-checkbox-circle-line text-lg" />
                  本页会做的事
                </div>
                <ul className="mt-2 space-y-1.5 text-sm text-foreground-600">
                  <li>同步最新入口与地址</li>
                  <li>提供换域名找回步骤</li>
                  <li>给出真伪辨别与安全提示</li>
                </ul>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <div className="flex items-center gap-2 text-secondary-800 font-medium text-sm">
                  <i className="ri-close-circle-line text-lg" />
                  本页不会做的事
                </div>
                <ul className="mt-2 space-y-1.5 text-sm text-foreground-600">
                  <li>不存储任何视频内容</li>
                  <li>不要求注册、付费或下载</li>
                  <li>不收集你的个人信息</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}